import { RentalListing } from '../rentalListing'
import { extractAsLeadOption } from './extract-as-lead-option'

export const isRoommatable = (listing: RentalListing, optionId?: number) => {
  const option = extractAsLeadOption(listing, optionId)
  return option?.type === 'PRIVATE_ROOM' && listing.address.country === 'US'
}
